import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  TableRow,
  TableCell,Link,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {Skeleton} from "@material-ui/lab";
import SortableTable from "../../shared/Tables/SortableTable";
import {toTitleCase} from "../../../../helpers/utils";

const TriggeringContactsSection = ({ contacts, fetching, open,handleOpenContactModal, ...props }) => {
  const [expandContacts, setExpandContacts] = useState(open);

  const toggleExpandContacts = () => {
    setExpandContacts(!expandContacts);
  }


  return(
    <React.Fragment>
      <Card style={{marginTop: '24px'}}
      >
        <CardHeader className='cursor-pointer' title={
            <span>
              <span>Triggering Contacts</span>
              <span className='float-right'>
                {
                  expandContacts ? <ExpandLess /> : <ExpandMore />
                }
              </span>
            </span>
          } onClick={toggleExpandContacts}
        />
        <Divider />
        <CardContent style={{padding: `${expandContacts ? '20px' : 0}`, overflowY: 'auto'}}>
          <Collapse in={expandContacts}>
            {
              fetching ? <Skeleton animation='pulse' variant='rect' height='100px' width='100%' component='div' /> : <SortableTable
                  headCells={[
                    { id: 'contact_first_name', numeric: false, disablePadding: false, label: 'First Name ' },
                    { id: 'contact_last_name', numeric: false, disablePadding: false, label: 'Last Name ' },
                    { id: 'contact_crd_id', numeric: false, disablePadding: false, label: 'CRD ' },
                  ]}
                  rows={contacts}
                  rowsPerPageDefault={50}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  RowRenderer={
                    (row, _isSelected, index, _handleCheck) => (<TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                        style={{cursor: "pointer"}}
                        onClick={(event) => (row.id)}
                    >
                      <TableCell>
                        <Link onClick={(event) => handleOpenContactModal(row.contact_crd_id, index)}>
                          {toTitleCase(row.contact_first_name)}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Link onClick={(event) => handleOpenContactModal(row.contact_crd_id, index)}>
                          {toTitleCase(row.contact_last_name)}
                        </Link>
                      </TableCell>
                      <TableCell>{row.contact_crd_id}</TableCell>
                    </TableRow>)
                  }
              />
            }
          </Collapse>
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default TriggeringContactsSection;